import React from 'react';
import { Alert, Box, Paper, Typography } from '@mui/material';

// Explicit extension: `./Markdown` would resolve to markdown.js first on a
// case-insensitive filesystem (webpack tries .js before .jsx) and fail the
// case-sensitive-paths check on macOS dev machines.
import Markdown from './Markdown.jsx';
import ToolChips from './ToolChips';

const MessageBubble = ({ message }) => {
  if (message.role === 'user') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2.5 }}>
        <Paper
          elevation={0}
          sx={{
            maxWidth: '80%',
            px: 2,
            py: 1.25,
            borderRadius: '14px 14px 4px 14px',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            whiteSpace: 'pre-wrap',
            fontSize: 15,
            lineHeight: 1.6,
          }}
        >
          {message.content}
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="caption"
        sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: 0.4, mb: 0.75, display: 'block' }}
      >
        ASSISTANT
      </Typography>

      <ToolChips calls={message.tool_calls} />

      {message.error ? (
        <Alert severity="error" sx={{ fontSize: 14 }}>
          {message.error}
        </Alert>
      ) : null}

      {message.content ? <Markdown text={message.content} /> : null}

      {/* The gap between "sent" and the first token — real, and worth naming. */}
      {!message.content && !message.error && message.pending ? (
        <Typography sx={{ color: 'text.secondary', fontSize: 14.5 }}>Thinking…</Typography>
      ) : null}
    </Box>
  );
};

export default MessageBubble;
